import React from 'react';
import useApi from './useApi';

import { LS_KEYS } from '../hooks';

const BASE_URL = '/order';

export const useOrder = () => {
  // ***********************************Backoffice*********************
  const { get, put } = useApi(LS_KEYS.BACKOFFICE);

  /**
   * Load a order (Backoffice)
   */
  const load = React.useCallback(
    async orderId => {
      const loadedOrder = await get(`${BASE_URL}/${orderId}`);
      return loadedOrder;
    },
    [get],
  );

  /**
   * Get last orders (Backoffice)
   */
  const getLastOrders = React.useCallback(async () => {
    const orderList = await get(BASE_URL);

    return !orderList
      ? []
      : orderList.map(
          ({
            _id,
            formatedDate,
            formatedTime,
            formatedTotal,
            formatedStatus,
            status,
            situation,
            client,
            items,
          }) => ({
            _id,
            date: formatedDate,
            hour: formatedTime,
            client: client.name,
            total: formatedTotal,
            formatedStatus,
            status,
            situation,
            items,
          }),
        );
  }, [get]);

  /**
   * Update a order (Backoffice)
   */
  const updateStatus = React.useCallback(
    (id, status) => {
      const updatedOrder = put(`${BASE_URL}/${id}/status`, { status });
      return updatedOrder;
    },
    [put],
  );
  // ***********************************Backoffice*********************
  const { post: postSite } = useApi(LS_KEYS.SITE);

  /**
   * Create a order (Site)
   */
  const createOrder = React.useCallback(
    async order => {
      const createdOrder = await postSite(BASE_URL, order);
      return createdOrder;
    },
    [postSite],
  );

  return { load, getLastOrders, updateStatus, createOrder };
};

export default useOrder;
